import type { PhysioPostureAssessment } from '../types/physiotherapyAssessment';

export const POSTURAL_LATERAL_FINDINGS = [
  { key: 'hip_anteverison', label: 'Anterversão de quadril' },
  { key: 'hip_retroversion', label: 'Retroversão de quadril' },
  { key: 'shoulder_internal_rotation', label: 'Rotação interna dos ombros' },
  { key: 'cervical_rectification', label: 'Retificação cervical' },
  { key: 'lumbar_rectification', label: 'Retificação lombar' },
  { key: 'abdominal_protrusion', label: 'Protusão abdominal' },
  { key: 'cervical_hyperlordosis', label: 'Hiperlordose cervical' },
  { key: 'lumbar_hyperlordosis', label: 'Hiperlordose lombar' },
  { key: 'thoracic_hyperkyphosis', label: 'Hipercifose torácica' },
  { key: 'flat_foot', label: 'Pé plano' },
  { key: 'cavus_foot', label: 'Pé cavo' },
  { key: 'calcaneal_foot', label: 'Pé calcâneo' },
  { key: 'equinus_foot', label: 'Pé equino' },
  { key: 'genu_flexum', label: 'Genu flexo' },
  { key: 'genu_recurvatum', label: 'Genu recurvado' },
] as const;

export const POSTURAL_POSTERIOR_FINDINGS = [
  { key: 'cervical_scoliosis', label: 'Escoliose cervical' },
  { key: 'lumbar_scoliosis', label: 'Escoliose lombar' },
  { key: 'thoracic_scoliosis', label: 'Escoliose torácica' },
  { key: 'scapular_protraction', label: 'Protração escapular' },
  { key: 'scapular_retraction', label: 'Retração escapular' },
  { key: 'scapular_depression', label: 'Depressão escapular' },
  { key: 'valgus_foot', label: 'Pé valgo' },
  { key: 'varus_foot', label: 'Pé varo' },
  { key: 'trapezius_shortening', label: 'Encurtamento do trapézio' },
] as const;

export const POSTURAL_ANTERIOR_LOWER_BODY = [
  { key: 'genu_valgum', label: 'Genu valgo' },
  { key: 'genu_varum', label: 'Genu varo' },
  { key: 'foot_adduction', label: 'Pé aduto' },
  { key: 'foot_abduction', label: 'Pé abduto' },
] as const;

export const POSTURAL_PHOTO_VIEWS = [
  { key: 'lateral_right', label: 'Visão lateral direita' },
  { key: 'lateral_left', label: 'Visão lateral esquerda' },
  { key: 'posterior', label: 'Visão posterior' },
  { key: 'anterior', label: 'Visão anterior' },
] as const;

export type PosturalPhotoViewKey = typeof POSTURAL_PHOTO_VIEWS[number]['key'];

export const POSTURAL_ASYMMETRY_OPTIONS = [
  { value: 'right_elevation', label: 'Elevação direita' },
  { value: 'left_elevation', label: 'Elevação esquerda' },
  { value: 'none', label: 'Nenhuma elevação' },
] as const;

export function emptyPostureAssessment(): PhysioPostureAssessment {
  return {
    photos: {
      lateral_right: null,
      lateral_left: null,
      posterior: null,
      anterior: null,
    },
    lateral_findings: [],
    posterior_findings: [],
    anterior_lower_body: [],
    hip_asymmetry: '',
    shoulder_asymmetry: '',
    observations: '',
    segments: [],
    alterations: '',
    movement_patterns: '',
  };
}

export function normalizePostureAssessment(raw?: Partial<PhysioPostureAssessment> | null): PhysioPostureAssessment {
  const base = emptyPostureAssessment();
  if (!raw) return base;
  return {
    ...base,
    ...raw,
    photos: {
      ...base.photos,
      ...(raw.photos || {}),
    },
    lateral_findings: raw.lateral_findings || [],
    posterior_findings: raw.posterior_findings || [],
    anterior_lower_body: raw.anterior_lower_body || [],
    segments: raw.segments || [],
  };
}

export function labelsFromPosturalKeys(
  keys: string[],
  catalog: ReadonlyArray<{ key: string; label: string }>,
): string {
  return keys.map((k) => catalog.find((c) => c.key === k)?.label || k).join('; ');
}

export function posturalAsymmetryLabel(value: string): string {
  return POSTURAL_ASYMMETRY_OPTIONS.find((o) => o.value === value)?.label || value;
}
